import { Box, Card, Typography, styled } from '@mui/material';
import React from 'react';
const SubHeaderContainer = styled(Box)(({ theme }) => {
    return {
        position: 'relative',
        backgroundColor: theme.palette.background.light,
        borderRadius: `${theme.spacing(1.5)} ${theme.spacing(1.5)} 0px 0px`,
        padding: theme.spacing(1.5, 2),
        color: theme.palette.text.primary,
        '&::before': {
            content: '""',
            position: 'absolute',
            insetInlineStart: 0,
            top: 0,
            bottom: 0,
            width: 3,
            borderRadius: `${theme.spacing(1.5)} 0px 0px 0px`,
            backgroundColor: theme.palette.primary.main,
        },
        [theme.breakpoints.up('md')]: {
            marginTop: 0,
        },
    };
});
const SubTitle = styled(Typography)(({ theme }) => {
    return {
        textAlign: 'center',
        fontSize: '14px',
        fontWeight: 'bold',
        [theme.breakpoints.up('md')]: {
            fontSize: '16px',
        },
    };
});
export const SubHeader = ({ title }: { title: string }) => {
    return (
        <SubHeaderContainer>
            <SubTitle>{title}</SubTitle>
        </SubHeaderContainer>
    );
};

export const CardWithHeader = ({
    title,
    children,
}: {
    title: string;
    children: React.ReactNode;
}) => {
    return (
        <Card>
            <SubHeader title={title} />
            <Box sx={{ p: 2 }}>{children}</Box>
        </Card>
    );
};
